<template>
  <div style="background-color: rgb(252, 252, 252)">
    <div class="main-content" style="background-color: white">
      <div>
        <div class="test-info-card">
          <div class="test-info-header">
            <h3 class="test-info-title">测试详情</h3>
          </div>
          <div class="test-info-content">
            <div class="test-info-row">
              <div class="test-info-item">
                <span class="test-info-label">学生姓名</span>
                <span class="test-info-value">{{ decodedQueryObject.targetCNName }}</span>
              </div>
              <div class="test-info-item">
                <span class="test-info-label">测试类型</span>
                <span class="test-info-value test-type-badge">{{ testTypeString }}</span>
              </div>
            </div>
            <div class="test-info-row">
              <div class="test-info-item">
                <span class="test-info-label">测试名称</span>
                <span class="test-info-value">{{ testItem.name }}</span>
              </div>
              <div class="test-info-item">
                <span class="test-info-label">测试来源</span>
                <span class="test-info-value">{{ testItem.origin }}</span>
              </div>
            </div>
            <div class="test-info-row">
              <div class="test-info-item full-width">
                <span class="test-info-label">测试描述</span>
                <span class="test-info-value">{{ testItem.description || '无' }}</span>
              </div>
            </div>
            <div class="test-info-row">
              <div class="test-info-item full-width">
                <span class="test-info-label">答题结果</span>
                <div class="test-result-info">
                  <span class="result-count">答对：<strong>{{ result.correct }}</strong> / {{ result.vocCount }}</span>
                  <span class="result-rate" :class="getResultRateClass()">
                    正确率：<strong>{{ Math.round((result.correct / result.vocCount) * 10000) / 100 }}%</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-divider />
      </div>

      <div class="test-table">
        <el-table
          ref="singleTableRef"
          :data="testItem.studentAnswers"
          highlight-current-row
          style="width: 100%"
          @current-change="handleCurrentChange"
        >
          <el-table-column type="index" width="50" />

          <el-table-column property="englishText" label="英文">
            <template #default="scope">
              <div
                @click="
                  handleEnglishTextColumnClick($event, scope.row.englishText)
                "
              >
                {{ scope.row.englishText }}
              </div>
            </template>
          </el-table-column>

          <el-table-column property="chineseText" label="释义">
            <template #default="scope">
              <div class="chinese-answer-item">
                <span v-html="scope.row.chineseText" />
              </div>
            </template>
          </el-table-column>

          <el-table-column
            property="aIcheckResult"
            label="发音评测"
            width="400"
          >
            <template #default="scope">
              <div
                v-if="getEvaluationResult(scope.row)"
                class="pronunciation-result"
              >
                <div class="overall-score">
                  <span class="score-label">总分：</span>
                  <span
                    :class="getScoreClass(getOverallScore(scope.row))"
                    class="score-value"
                  >
                    {{ getOverallScore(scope.row) }}
                  </span>
                </div>
                <div class="word-details">
                  <div
                    v-for="(detail, index) in getEvaluationDetails(scope.row)"
                    :key="index"
                    class="word-detail-item"
                  >
                    <div class="word-header">
                      <span class="word-text">{{ detail.char }}</span>
                      <span
                        :class="getScoreClass(detail.score)"
                        class="word-score"
                      >
                        {{ detail.score }}分
                      </span>
                    </div>
                    <div class="phonics-container">
                      <span
                        v-for="(phonic, pIndex) in detail.phonics"
                        :key="pIndex"
                        :class="getScoreClass(phonic.overall)"
                        class="phonic-item"
                        :title="`${phonic.spell}: ${phonic.overall}分`"
                      >
                        <span class="phonic-char">{{ phonic.spell }}</span>
                        <span class="phonic-score">{{ phonic.overall }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <span v-else class="no-evaluation">未评测</span>
            </template>
          </el-table-column>

          <el-table-column
            property="audioBase64str"
            label="答案音频"
            width="300"
          >
            <template #default="scope">
              <div
                v-if="
                  scope.row.audioBase64str &&
                  scope.row.audioBase64str.trim() !== ''
                "
                class="audio-player-container"
              >
                <div
                  :ref="`audio-player-container-${scope.row.id}`"
                  :id="`audio-player-container-${scope.row.id}`"
                  class="chivox-player-container"
                ></div>
                <div class="audio-controls">
                  <el-button
                    v-if="!isPlaying(scope.row.id)"
                    type="primary"
                    size="small"
                    @click="playAudio(scope.row)"
                    icon="VideoPlay"
                  >
                    播放
                  </el-button>
                  <el-button
                    v-else
                    type="warning"
                    size="small"
                    @click="stopAudio(scope.row.id)"
                    icon="VideoPause"
                  >
                    停止
                  </el-button>
                </div>
              </div>
              <span v-else class="no-audio">无音频</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <audio ref="vocaudio"></audio>
      </div>
    </div>
  </div>
</template>

<script>
import Html5Player from 'chivox_h5sdk/src/html5/html5player'

export default {
  name: 'SpeakEnglishTestItemResult',

  components: {},

  computed: {
    testTypeString () {
      switch (this.testItem.type) {
        case 7:
          return '看英说英'
        default:
          return ''
      }
    }
  },

  data () {
    return {
      testItem: {},
      decodedQueryObject: null,
      currentRow: {},
      result: {
        correct: 0,
        vocCount: 0
      },
      userRole: '',
      // 存储每个音频的播放状态
      playingStatus: new Map(),
      // 存储每个音频的 Html5Player 实例
      audioPlayers: new Map()
    }
  },

  beforeMount: function () {
    let queryString = window.atob(this.$route.query.encodedString)
    queryString = window.decodeURIComponent(queryString)
    this.decodedQueryObject = JSON.parse(queryString)
  },

  mounted: function () {
    this.userRole = localStorage.getItem('userRole')
    this.getTestById(
      this.decodedQueryObject.id,
      this.decodedQueryObject.studentId
    )
  },

  beforeUnmount: function () {
    // 停止所有正在播放的音频
    this.stopAllAudio()
    // 清理所有 Html5Player 实例
    this.cleanupAllPlayers()
  },

  methods: {
    getTestById: function (testId, studentId) {
      this.$store
        .dispatch('StudentTest/getTestById', {
          id: testId,
          userId: studentId,
          includeAudio: true
        })
        .then(response => {
          this.testItem = response.data
          this.calculateResult()
          // 数据加载完成后，初始化所有音频播放器
          this.$nextTick(() => {
            this.initializeAllPlayers()
          })
        })
        .catch(error => {
          this.$message(error.toString())
        })
    },

    calculateResult: function () {
      this.result.vocCount = this.testItem.studentAnswers.length
      this.result.correct = this.testItem.studentAnswers.filter(
        item => item.isCorrect
      ).length
    },

    handleCurrentChange: function (val) {
      this.currentRow = val
    },

    handleEnglishTextColumnClick: function (event, englishText) {
      this.$playAudio(englishText, this.$refs.vocaudio)
    },

    // 获取评测结果对象
    getEvaluationResult: function (row) {
      if (!row.aIcheckResult) return null
      try {
        return typeof row.aIcheckResult === 'string'
          ? JSON.parse(row.aIcheckResult)
          : row.aIcheckResult
      } catch (error) {
        console.error('解析评测结果失败:', error)
        return null
      }
    },

    // 获取总体得分
    getOverallScore: function (row) {
      const result = this.getEvaluationResult(row)
      return result ? result.overall || 0 : 0
    },

    // 获取单词详情数组
    getEvaluationDetails: function (row) {
      const result = this.getEvaluationResult(row)
      return result && result.details ? result.details : []
    },

    // 根据得分获取样式类
    getScoreClass: function (score) {
      if (score >= 90) return 'score-excellent'
      if (score >= 80) return 'score-good'
      if (score >= 70) return 'score-fair'
      if (score >= 60) return 'score-poor'
      return 'score-very-poor'
    },

    // 根据正确率获取样式类
    getResultRateClass: function () {
      const rate = (this.result.correct / this.result.vocCount) * 100
      if (rate >= 90) return 'result-rate-excellent'
      if (rate >= 80) return 'result-rate-good'
      if (rate >= 70) return 'result-rate-fair'
      if (rate >= 60) return 'result-rate-poor'
      return 'result-rate-very-poor'
    },


    // 初始化所有音频播放器
    initializeAllPlayers: function () {
      if (!this.testItem || !this.testItem.studentAnswers) {
        return
      }
      
      this.testItem.studentAnswers.forEach(answer => {
        if (answer.audioBase64str && answer.audioBase64str.trim() !== '') {
          this.initializePlayer(answer)
        }
      })
    },

    // 初始化单个音频播放器
    initializePlayer: function (row) {
      const rowId = row.id
      const containerId = `audio-player-container-${rowId}`
      const container = document.getElementById(containerId)
      
      if (!container) {
        console.warn('找不到音频容器:', containerId)
        return
      }

      // 如果已经初始化过，先清理
      if (this.audioPlayers.has(rowId)) {
        const oldPlayer = this.audioPlayers.get(rowId)
        try {
          oldPlayer.stop()
          oldPlayer.destroy()
        } catch (error) {
          console.warn('清理旧播放器失败:', error)
        }
      }

      try {
        // 创建 Html5Player 实例（不传入音频URL，稍后通过load方法加载）
        const player = new Html5Player({
          onInit: (mess) => {
            console.log('Html5Player 初始化成功:', rowId, mess)
          },
          onError: (error) => {
            console.error('Html5Player 错误:', rowId, error)
            this.$message.error('音频播放器错误: ' + (error.message || JSON.stringify(error)))
            this.playingStatus.set(rowId, false)
          }
        })

        this.audioPlayers.set(rowId, player)
        console.log('Html5Player 创建成功:', rowId)
      } catch (error) {
        console.error('创建 Html5Player 失败:', rowId, error)
        this.$message.error('创建音频播放器失败: ' + (error.message || '未知错误'))
      }
    },

    // 播放音频
    playAudio: function (row) {
      const rowId = row.id
      
      // 如果播放器未初始化，先初始化
      if (!this.audioPlayers.has(rowId)) {
        this.initializePlayer(row)
        // 等待初始化完成
        this.$nextTick(() => {
          this.playAudio(row)
        })
        return
      }

      const player = this.audioPlayers.get(rowId)
      if (!player) {
        console.error('播放器不存在:', rowId)
        return
      }

      const audioUrl = this.getAudioUrl(row)
      if (!audioUrl) {
        console.warn('无法获取音频 URL:', row)
        this.$message.warning('无法获取音频地址')
        return
      }

      try {
        // 停止其他正在播放的音频
        this.stopAllOtherAudio(rowId)
        
        // 使用 load 方法加载音频
        player.load({
          url: audioUrl,
          success: (code, message) => {
            console.log('音频加载成功:', rowId, code, message)
            // 播放音频
            player.play({
              position: 0,
              onStop: () => {
                console.log('player onStop:', rowId)
                this.handleAudioPause(rowId)
              },
              onStart: () => {
                console.log('player onStart:', rowId)
                this.handleAudioPlay(rowId)
              }
            })
          },
          error: (err) => {
            console.error('player load error:', rowId, err)
            console.error('音频URL:', audioUrl)
            console.error('错误详情:', JSON.stringify(err, null, 2))
            
            
            const errorMsg = err && err.message ? err.message : (typeof err === 'string' ? err : JSON.stringify(err))
            this.$message.error('加载音频失败: ' + errorMsg)
            this.playingStatus.set(rowId, false)
          }
        })
      } catch (error) {
        console.error('播放音频失败:', rowId, error)
        this.$message.error('播放音频失败: ' + (error.message || '未知错误'))
        this.playingStatus.set(rowId, false)
      }
    },

    // 停止音频
    stopAudio: function (rowId) {
      if (!this.audioPlayers.has(rowId)) {
        return
      }

      const player = this.audioPlayers.get(rowId)
      if (!player) {
        return
      }

      try {
        player.stop()
      } catch (error) {
        console.error('停止音频失败:', rowId, error)
      }
    },



    // 获取音频 URL（处理 Chivox 音频地址格式）
    getAudioUrl: function (row) {
      const rowId = row.id
      // 调试：打印原始数据
      console.log(
        'getAudioUrl - row.audioBase64str:',
        row.audioBase64str ? row.audioBase64str.substring(0, 100) + '...' : 'null',
        'row.id:',
        rowId
      )

      if (!row.audioBase64str || row.audioBase64str.trim() === '') {
        console.log('audioBase64str 为空或未定义')
        return null
      }

      const audioStr = row.audioBase64str.trim()

      // 如果已经是完整的 URL（包含 http:// 或 https://），直接返回
      if (audioStr.startsWith('http://') || audioStr.startsWith('https://')) {
        console.log('检测到完整 URL:', audioStr)
        return audioStr
      }

      // 如果是 data URL（以 data: 开头），直接返回（浏览器可以直接播放）
      if (audioStr.startsWith('data:')) {
        console.log('检测到 data URL，直接使用')
        return audioStr
      }

      // 如果是 Chivox 音频 URL 格式（如：jpdownload.cloud.chivox.com:8002/693442aca4d5174e99158a2a）
      // 需要添加 http:// 协议，并在末尾添加 .mp3
      // 检查是否包含 chivox 相关域名或 jpdownload
      if (
        audioStr.includes('cloud.chivox.com') ||
        audioStr.includes('chivox.com') ||
        audioStr.includes('jpdownload') ||
        audioStr.includes('chivox')
      ) {
        const url = `http://${audioStr}.mp3`
        console.log('检测到 Chivox URL，转换为:', url)
        return url
      }

      // 如果包含端口号和斜杠（如 :8002/），可能是 Chivox 或其他服务的 URL
      if (audioStr.includes(':') && audioStr.includes('/')) {
        // 检查是否包含域名格式（包含点）
        if (audioStr.includes('.')) {
          // 检查是否已经是 Chivox URL（可能没有明确标识）
          if (!audioStr.endsWith('.mp3') && !audioStr.endsWith('.wav') && !audioStr.endsWith('.m4a')) {
            const url = `http://${audioStr}.mp3`
            console.log('检测到带端口的域名 URL，添加 .mp3 后缀:', url)
            return url
          } else {
            const url = `http://${audioStr}`
            console.log('检测到带端口的域名 URL，转换为:', url)
            return url
          }
        }
      }

      // 如果都不匹配，但字符串不为空，尝试作为 URL 处理（可能是域名格式）
      if (
        audioStr.length > 10 &&
        (audioStr.includes('.') || audioStr.includes('/'))
      ) {
        const url = `http://${audioStr}`
        console.log('尝试作为 URL 处理:', url)
        return url
      }

      console.log('无法识别音频格式，返回 null')
      return null
    },


    // 检查是否正在播放
    isPlaying: function (rowId) {
      return this.playingStatus.get(rowId) || false
    },

    // 处理音频播放事件
    handleAudioPlay: function (rowId) {
      // 停止其他正在播放的音频
      this.stopAllOtherAudio(rowId)
      this.playingStatus.set(rowId, true)
    },

    // 处理音频暂停事件
    handleAudioPause: function (rowId) {
      this.playingStatus.set(rowId, false)
    },

    // 处理音频结束事件
    handleAudioEnded: function (rowId) {
      this.playingStatus.set(rowId, false)
    },

    // 清理所有播放器
    cleanupAllPlayers: function () {
      this.audioPlayers.forEach((player, rowId) => {
        try {
          player.stop()
          player.destroy()
          console.log('清理播放器:', rowId)
        } catch (error) {
          console.warn('清理播放器失败:', rowId, error)
        }
      })
      this.audioPlayers.clear()
    },

    // 停止所有音频
    stopAllAudio: function () {
      this.audioPlayers.forEach((player, rowId) => {
        try {
          player.stop()
          this.playingStatus.set(rowId, false)
        } catch (error) {
          console.warn('停止音频失败:', rowId, error)
        }
      })
      this.playingStatus.clear()
    },

    // 停止其他正在播放的音频
    stopAllOtherAudio: function (currentRowId) {
      this.audioPlayers.forEach((player, rowId) => {
        if (rowId !== currentRowId) {
          try {
            player.stop()
            this.playingStatus.set(rowId, false)
          } catch (error) {
            console.warn('停止音频失败:', rowId, error)
          }
        }
      })
    },


  }
}
</script>

<style scoped lang="scss">
.main-content {
  margin: 20px;
  padding: 20px;
}

.test-item {
  margin-bottom: 20px;
}

.div-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.test-item-details {
  p {
    margin: 5px 0;
  }
}

.test-info-card {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e4e7ed;
}

.test-info-header {
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e4e7ed;
}

.test-info-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0;
  display: flex;
  align-items: center;
  
  &::before {
    content: '';
    display: inline-block;
    width: 4px;
    height: 20px;
    background: linear-gradient(135deg, #409eff 0%, #67c23a 100%);
    border-radius: 2px;
    margin-right: 12px;
  }
}

.test-info-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.test-info-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.test-info-item {
  display: flex;
  flex-direction: column;
  gap: 8px;
  
  &.full-width {
    grid-column: 1 / -1;
  }
}

.test-info-label {
  font-size: 13px;
  color: #909399;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.test-info-value {
  font-size: 15px;
  color: #303133;
  font-weight: 500;
  word-break: break-word;
}

.test-type-badge {
  display: inline-block;
  padding: 4px 12px;
  background: linear-gradient(135deg, #409eff 0%, #67c23a 100%);
  color: white;
  border-radius: 12px;
  font-size: 13px;
  font-weight: 600;
}

.test-result-info {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
}

.result-count {
  font-size: 15px;
  color: #606266;
  
  strong {
    color: #303133;
    font-weight: 600;
  }
}

.result-rate {
  font-size: 16px;
  font-weight: 500;
  padding: 6px 16px;
  border-radius: 20px;
  
  strong {
    font-weight: 700;
    font-size: 18px;
  }
  
  &.result-rate-excellent {
    background: linear-gradient(135deg, #f0f9ff 0%, #e8f5e9 100%);
    color: #67c23a;
    
    strong {
      color: #67c23a;
    }
  }
  
  &.result-rate-good {
    background: linear-gradient(135deg, #ecf5ff 0%, #e3f2fd 100%);
    color: #409eff;
    
    strong {
      color: #409eff;
    }
  }
  
  &.result-rate-fair {
    background: linear-gradient(135deg, #fdf6ec 0%, #fff3e0 100%);
    color: #e6a23c;
    
    strong {
      color: #e6a23c;
    }
  }
  
  &.result-rate-poor {
    background: linear-gradient(135deg, #fef0f0 0%, #ffebee 100%);
    color: #f56c6c;
    
    strong {
      color: #f56c6c;
    }
  }
  
  &.result-rate-very-poor {
    background: linear-gradient(135deg, #f4f4f5 0%, #eceff1 100%);
    color: #909399;
    
    strong {
      color: #909399;
    }
  }
}

.test-table {
  margin-top: 20px;
}

.english-answer-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.english-answer-item-result-correct {
  display: flex;
  align-items: center;
}

.english-answer-item-result-incorrect {
  display: flex;
  align-items: center;
}

.chinese-answer-item {
  word-break: break-word;
}

.pronunciation-result {
  padding: 10px;
  background-color: #f8f9fa;
  border-radius: 6px;
}

.overall-score {
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e0e0e0;
}

.score-label {
  font-weight: 600;
  color: #333;
  font-size: 14px;
}

.score-value {
  font-size: 20px;
  font-weight: bold;
  margin-left: 8px;
}

.word-details {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.word-detail-item {
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  border-left: 3px solid #409eff;
}

.word-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.word-text {
  font-weight: 600;
  font-size: 16px;
  color: #333;
}

.word-score {
  font-size: 14px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
}

.phonics-container {
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  align-items: center;
}

.phonic-item {
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 4px 6px;
  padding-top: 6px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid transparent;
  min-width: 24px;
  flex-shrink: 0;
}

.phonic-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}

.phonic-char {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.2;
}

.phonic-score {
  position: absolute;
  top: -3px;
  right: -3px;
  font-size: 9px;
  font-weight: 700;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 6px;
  padding: 0px 3px;
  min-width: 14px;
  text-align: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  line-height: 1.3;
}

/* 得分颜色样式 */
.score-excellent {
  color: #67c23a;
  background-color: #f0f9ff;
  border-color: #67c23a;
}

.score-good {
  color: #409eff;
  background-color: #ecf5ff;
  border-color: #409eff;
}

.score-fair {
  color: #e6a23c;
  background-color: #fdf6ec;
  border-color: #e6a23c;
}

.score-poor {
  color: #f56c6c;
  background-color: #fef0f0;
  border-color: #f56c6c;
}

.score-very-poor {
  color: #909399;
  background-color: #f4f4f5;
  border-color: #909399;
}

.no-evaluation {
  color: #909399;
  font-style: italic;
}

.audio-player-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px 0;
  gap: 8px;
}

.chivox-player-container {
  width: 100%;
  min-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.audio-controls {
  display: flex;
  gap: 8px;
}

.no-audio {
  color: #909399;
  font-style: italic;
}
</style>
